import { render, staticRenderFns } from "./config-format-picker.mpx?vue&type=template&id=dff77b0c&isComponent&outputPath=components%2Fconfig-format-picker3fb927dd%2Findex"
import script from "./config-format-picker.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fconfig-format-picker3fb927dd%2Findex"
export * from "./config-format-picker.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fconfig-format-picker3fb927dd%2Findex"
import style0 from "./config-format-picker.mpx?vue&type=style&index=0&id=dff77b0c&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_3fb927dd%22%7D&isComponent&outputPath=components%2Fconfig-format-picker3fb927dd%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports